var _rect, _rect2, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpwardsGraphInCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#paint0_linear_156_3058)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#pattern0)",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3506 46.3562C27.3506 48.262 27.3506 50.1737 27.3506 52.0795C27.3506 52.4811 27.2518 52.505 25.0139 52.499C19.1886 52.487 20.0443 52.6309 20.0443 51.6001C20.0114 47.9563 20.0443 44.3066 20.0443 40.6628C20.0443 40.2014 20.0772 40.1954 22.6443 40.1954C23.5329 40.1954 24.3886 40.2074 25.2772 40.1954C26.824 40.1714 27.4164 40.2853 27.3835 40.5729C27.3506 42.5027 27.3506 44.4324 27.3506 46.3562Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6572 41.4413C39.6572 44.8717 39.6572 48.3129 39.6572 51.7433C39.6572 52.466 39.5585 52.5092 37.3205 52.4984C31.4952 52.4768 32.3509 52.7357 32.3509 50.8803C32.318 44.3215 32.3509 37.752 32.3509 31.1932C32.3509 30.3626 32.3838 30.3518 34.9509 30.3518C35.8395 30.3518 36.6952 30.3734 37.5838 30.3518C39.1306 30.3086 39.723 30.5136 39.6901 31.0314C39.6572 34.5049 39.6572 37.9785 39.6572 41.4413Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9658 36.5262C51.9658 41.4812 51.9658 46.4518 51.9658 51.4069C51.9658 52.4509 51.8671 52.5132 49.6291 52.4976C43.8038 52.4664 44.6595 52.8404 44.6595 50.1603C44.6266 40.6866 44.6595 31.1972 44.6595 21.7235C44.6595 20.5237 44.6924 20.5081 47.2595 20.5081C48.1481 20.5081 49.0038 20.5392 49.8924 20.5081C51.4392 20.4457 52.0316 20.7418 51.9987 21.4897C51.9658 26.5071 51.9658 31.5244 51.9658 36.5262Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_156_3058",
    transform: "translate(0 -0.207407) scale(0.000925926)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_156_3058",
    x1: 39.9333,
    y1: 83.2,
    x2: 15.8,
    y2: -32.1333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFECE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F9F8",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwardsGraphInCircle);
export default __webpack_public_path__ + "static/media/upwardsGraphInCircle.21f366803c7e2c587a2d5db141253402.svg";
export { ForwardRef as ReactComponent };